import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {PowerSelect} from 'react-power-select';

const CustomOptionComponent = ({ option }) => (
<div>
  <strong>{option.company.short_name}</strong>&nbsp;
  <img
    src={"/user-images/"+option.id}
    className="drivers-powerselect-driver-image"
  />
  <span>{option.first_name} {option.last_name}</span>
</div>
);

export default class HaulierDriversPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      drivers: props.driversAll || [],
      defaultValue: props.defaultValue || '',
      job: props.job || '',
      selectedOption: '',
      isZonePage:props.isZonePage || false
    };
    Echo.
      channel('group-planning-zonetable-update').
      listen('GroupPlanningZoneTableUpdate', (e) => {
        if(this.state.job.id == e.jobId && this.state.isZonePage){
          let that = this;
          $.ajax({
            url: "/api/v1/portal/drivers/default/for-dropdown-menu-haulier/"+e.jobId,
            data: {api_token: window.api_token},
            cache: false
          })
          .done(function(defaultDriverJson) {
            that.setState({selectedOption: defaultDriverJson});
          });
        }
    });
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.getDefaultDriver();
    this.getDrivers();
  }

  getDefaultDriver() {
    let that = this;
    if(that.state.job){
      $.ajax({
        url: "/api/v1/portal/drivers/default/for-dropdown-menu-haulier/"+that.state.job.id,
        data: {api_token: window.api_token},
        cache: false
      })
      .done(function(defaultDriverJson) {
        that.setState({
          selectedOption: defaultDriverJson
        });
      });
    }
  }

  getDrivers() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/all/for-dropdown-menu-haulier",
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(driversJson) {
      that.setState({ drivers: driversJson});
    });
  }

  handleChange( { option })  {
    this.setState({
      selectedOption: option,
    })
    this.props.handleHaulierDriverSelection(option);
  }

  render() {
    return (
      <PowerSelect
        options={this.state.drivers}
        optionLabelPath="full_name"
        selected={this.state.selectedOption}
        onChange={this.handleChange}
        placeholder="-- select a Hualier -- "
        optionComponent={<CustomOptionComponent />}
        required
        />
    )
  }
}
